import { useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAppSwitcherContext } from '../AppSwitcherProvider';

export type Tab = {
  name: string;
  title: string;
  content: React.ReactNode;
};

type TabViewProps = {
  tabs: Tab[];
  prefix?: string;
};

export const TabView = ({ tabs, prefix }: TabViewProps) => {
  const { pathname } = useLocation();
  const { app } = useAppSwitcherContext();

  const getRoute = useCallback(
    (tab: Tab) => (prefix ? `/${prefix}/${tab.name}` : `/${tab.name}`),
    [prefix]
  );

  const isActiveTab = useCallback(
    (tab: Tab, index: number) => {
      const route = getRoute(tab);
      const isExactMatch =
        pathname.endsWith(route) || pathname.includes(`${route}/`);
      if (!isExactMatch && index === 0 && prefix) {
        const basePath = `/${prefix}`;
        return pathname.endsWith(basePath) || pathname === basePath;
      }
      return isExactMatch;
    },
    [pathname, getRoute, prefix]
  );

  return (
    <div style={{ width: '100%', padding: 20 }}>
      <nav
        style={{
          display: 'inline-flex',
          gap: 4,
          padding: 4,
          borderRadius: 10,
          background: '#f1f5f9',
        }}
      >
        {tabs.map((tab, index) => {
          const active = isActiveTab(tab, index);
          return (
            <Link
              key={tab.name}
              to={getRoute(tab)}
              style={{
                padding: '8px 16px',
                borderRadius: 8,
                fontSize: 13,
                fontWeight: active ? 600 : 500,
                color: active ? '#0f172a' : '#64748b',
                background: active ? '#ffffff' : 'transparent',
                boxShadow: active ? '0 1px 3px rgba(15, 23, 42, 0.08)' : 'none',
                textDecoration: 'none',
                transition: 'all 0.15s ease',
              }}
            >
              {tab.title}
            </Link>
          );
        })}
      </nav>

      <div style={{ width: '100%', padding: '20px 0' }}>
        {tabs.find((tab, index) => isActiveTab(tab, index))?.content ||
          tabs[0]?.content ||
          null}
      </div>
    </div>
  );
};
